<template>
    <div id="driver_commission_policies" class="x_scrollable">

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="!is_initialized">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="(driver_commission_policy, index) in driver_commission_policies"
                    :key="driver_commission_policy.identity"
                    :object="driver_commission_policy"
                    :title="index+1+'.'"
                    :title_link="{name: 'driver_commission_policy', params: {identity: driver_commission_policy.identity}}"
                    :sub_title="driver_commission_policy.is_activated ? `<i class='ui icon check'></i>` : ''"
                    :color="driver_commission_policy.is_activated ? 'green': ''"
                    :is_show_column="true"
                    :keys="['table.general_pickup','table.general_delivery','table.bag_pick','table.bag_delivery']"
                    :i_18n_key="'driver_commission_policies'"
                >
                    <span slot="table.general_pickup">
                        <!-- 首重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_weight') }}: {{ driver_commission_policy.pick_up_first_weight }} /
                        <!-- 首重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_price') }}: {{ driver_commission_policy.pick_up_first_price }} /
                        <!-- 續重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}: {{ driver_commission_policy.pick_up_follow_up_weight }} /
                        <!-- 續重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}: {{ driver_commission_policy.pick_up_follow_up_price }}
                    </span>
                    <span slot="table.general_delivery">
                        <!-- 首重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_weight') }}: {{ driver_commission_policy.delivery_first_weight }} /
                        <!-- 首重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_price') }}: {{ driver_commission_policy.delivery_first_price }} /
                        <!-- 續重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}: {{ driver_commission_policy.delivery_follow_up_weight }} /
                        <!-- 續重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}: {{ driver_commission_policy.delivery_follow_up_price }}
                    </span>
                    <span slot="table.bag_pick">
                        <!-- 首重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_weight') }}: {{ driver_commission_policy.house_pick_up_first_weight }} /
                        <!-- 首重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_price') }}: {{ driver_commission_policy.house_pick_up_first_price }} /
                        <!-- 續重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}: {{ driver_commission_policy.house_pick_up_follow_up_weight }} /
                        <!-- 續重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}: {{ driver_commission_policy.house_pick_up_follow_up_price }}
                    </span>
                    <span slot="table.bag_delivery">
                        <!-- 首重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_weight') }}: {{ driver_commission_policy.house_delivery_first_weight }} /
                        <!-- 首重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.first_price') }}: {{ driver_commission_policy.house_delivery_first_price }} /
                        <!-- 續重 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}: {{ driver_commission_policy.house_delivery_follow_up_weight }} /
                        <!-- 續重價 -->
                        {{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}: {{ driver_commission_policy.house_delivery_follow_up_price }}
                    </span>
                    <div slot="buttons">
                        <button class="ui basic primary button" @click.prevent="toggle_activation(driver_commission_policy)">
                            <!-- 啟用開關 -->
                            {{ $t('ui.pages.driver_commission_policies.activated_switch') }}
                        </button>
                    </div>
                </DataCard>
            </div>
            <table v-else class="ui structured celled table">
                <thead>
                    <tr>
                        <th colspan="4" class="center aligned">
                            <!-- 一般取件 -->
                            {{ $t('ui.pages.driver_commission_policies.table.general_pickup') }}
                        </th>
                        <th colspan="4" class="center aligned">
                            <!-- 一般送件 -->
                            {{ $t('ui.pages.driver_commission_policies.table.general_delivery') }}
                        </th>
                        <th colspan="4" class="center aligned">
                            <!-- 袋裝取件 -->
                            {{ $t('ui.pages.driver_commission_policies.table.bag_pick') }}
                        </th>
                        <th colspan="4" class="center aligned">
                            <!-- 袋裝送件 -->
                            {{ $t('ui.pages.driver_commission_policies.table.bag_delivery') }}
                        </th>
                        <th rowspan="2">
                            <!-- 啟用 -->
                            {{ $t('ui.pages.driver_commission_policies.activated') }}
                        </th>
                        <th rowspan="2"></th>
                    </tr>

                    <tr>
                        <th>
                            <!-- 首重 -->
                            {{ $t('ui.pages.driver_commission_policies.table.first_weight') }}
                        </th>
                        <th>
                            <!-- 首重價 -->
                            {{ $t('ui.pages.driver_commission_policies.table.first_price') }}
                        </th>
                        <th>
                            <!-- 續重 -->
                            {{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}
                        </th>
                        <th>
                            <!-- 續重價 -->
                            {{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}
                        </th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_price') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_price') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.first_price') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_weight') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_policies.table.follow_up_price') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <DriverCommissionPolicy v-if="is_initialized" :key="driver_commission_policy.identity" v-for="driver_commission_policy in driver_commission_policies" :driver_commission_policy="driver_commission_policy">
                    </DriverCommissionPolicy>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DriverCommissionPolicy from "../.components/index/item.vue"
import DataCard from '@toolbox/data_card/main.vue'

export default {
    name: "DriverCommissionPoliciesIndex",
    data() {
        return {
            driver_commission_policies: [],
            is_initialized: false,
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "driver_commission_policies") {
                this.init()
            }
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.fetch_driver_commission_policies()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_driver_commission_policies() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policies).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.driver_commission_policies = response.data.driver_commission_policies
                })
                .catch(error => {
                })
        },
        toggle_activation(driver_commission_policy) {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policy_update).parse(
                {
                    "driver_commission_policy_identity": driver_commission_policy.identity,
                },
                ""
            )

            axios.post(url, { is_activated: !driver_commission_policy.is_activated }, { headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                if (response.data.status == "success") {
                    // this.$noty.success("收派件提成政策更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.driver_commission_policies')
                        })
                    )
                this.$parent.init()
                } else {
                    // this.$noty.error("收派件提成政策更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.driver_commission_policies'),
                            reason: ': ' + response.data.errors
                        })
                    )
                    this.errors = response.data.errors
                }
            })
            .catch(error => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                }
            })
        },
    },
    components: {
        DriverCommissionPolicy,
        DataCard
    }
}
</script>
